<template>
    <nav v-if="role == 'booster'">                    
        <v-rating
            :value=0
            :length=question.allowed_options
            align="center"
            class="survey-rating"
            readonly
            data-testid="rating-numbers"
        >
            <template v-slot:item="props">
                <v-icon
                    :class="props.isFilled ? 'rating-filled' : 'rating-notfilled'"
                    :color="props.isFilled ? 'accent' : ''"
                    v-text="`mdi-numeric-${props.index + 1}`"
                    @click="props.click"
                    large
                ></v-icon>
            </template>
        </v-rating>
    </nav>
    <nav v-else>                    
        <v-rating
            v-model="rating"
            :length=question.allowed_options
            align="center"
            class="survey-rating"
            data-testid="rating-numbers"
            @input="answerQuestion()"
        >
            <template v-slot:item="props">
                <v-icon
                    :class="props.isFilled ? 'rating-filled' : 'rating-notfilled'"
                    :color="props.isFilled ? 'accent' : ''"
                    v-text="`mdi-numeric-${props.index + 1}`"
                    @click="props.click"
                    large
                ></v-icon>
            </template>
        </v-rating>
        <v-row no-gutters>
          <v-col cols="12" md="7" class="mx-auto">
            <p v-if="showError" class="error--text font-italic pt-3">{{ $t('answerError') }}</p>
          </v-col>
        </v-row>
    </nav>
</template>
<script>
export default {
  props: {
    question: {
      type: Object,
      default: () => {}
    },
    role: {
      type: String,
      default: 'booster'
    },
    invalidAnswers: {
      type: Array,
      default: () => []
    },
    hasSubmittedSurvey:{
      type: Boolean,
      default: false
    }
  },
  data(){
    return{
      rating: 0,
      answerObject: {
        type: this.question.type,
        id: this.question.id,
        rating: 0
      },
      showError: false
    }
  },
  created(){
    //check if question was already submitted
    // const found = this.answers.find(object => object.id  == this.question.id);
    // if(found){
    //   this.answerObject = found
    // }
    this.$emit('sendAnswer', this.answerObject)
  },
  watch: {
    invalidAnswers() {
      this.showError = false
      if (this.hasSubmittedSurvey && this.invalidAnswers.includes(this.question.id)) {
        this.showError = true
      }
    },
  },
  methods: {
    answerQuestion(){
      this.answerObject.rating = this.rating
      this.$emit('sendAnswer', this.answerObject)
    }
  }
}
</script>